export const assignment = {
  input: {
    variables: "Variables",
    variablesValues: {
      key: "Key",
      value: "Value"
    }
  }
};
